// extracted by mini-css-extract-plugin
export var colorSquare = "_nm-0";
export var danger = "_nm-5";
export var lightPink = "_nm-8";
export var neutralBlue = "_nm-7";
export var neutralYellow = "_nm-6";
export var normal = "_nm-1";
export var primary = "_nm-2";
export var primaryLight = "_nm-3";
export var solidBlack = "_nm-g";
export var solidGreen = "_nm-b";
export var solidLightBlue = "_nm-d";
export var solidNavy = "_nm-c";
export var solidOrange = "_nm-f";
export var solidPink = "_nm-e";
export var solidRed = "_nm-9";
export var solidYellow = "_nm-a";
export var success = "_nm-4";